/**
 * Module act as a wrapper around the XMLHttpRequest
 * for handling presigned URL upload.
 * Module should be initialized by calling the init function and passing
 * corresponding methods for handling different event states of xhr upload.
 */
export default class PresignedAssetUploadXHR {
  _httpMethod = 'PUT';
  xhr = new XMLHttpRequest();

  constructor(method) {
    this._httpMethod = method || this._httpMethod;
  }

  init = ({ url, onLoad, onProgress, onError }) => {
    this._url = url;
    this.xhr.upload.onload = onLoad;
    this.xhr.upload.onprogress = (progressEvent) => onProgress(progressEvent);
    this.xhr.upload.onerror = onError;
  }

  send = (file) => {
    this.xhr.open(this._httpMethod, this._url);
    this.xhr.onloadend = () => {
      // To handle those cases which wont trigger an onerror event.
      if (this.xhr.status >= 400) {
        this.xhr.upload.onerror();
      }
    };
    this.xhr.setRequestHeader('Content-Type', file.type);
    this.xhr.setRequestHeader(
      'Content-Disposition',
      `attachment; filename="${file.name}"`
    );
    this.xhr.send(file);
  }

  abort = (callbackFn) => {
    this.xhr.abort();
    if (callbackFn) {
      callbackFn();
    }
  }
}
